<template>
    <h4>AddPersonAdmin.vue</h4>
  </template>
  
  <script>
  export default {
    data() {return{};},
    created() {
      this.$router.push({ name: 'addPerson', 
                            params: { contractId: -1, 
                                      contractNumber: 'abc'} });

    },
    computed: {},
    methods: {},
  };
  </script>
  
  <style scoped></style>
  